import React, { useEffect, useState, useRef } from "react";
import api from "../../utils/api";
import APIConstant from "../../utils/constant";
import Loader from "components/Shared/Loader/Loader";
import SimpleBackdrop from "utils/general";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import { MultiSelect } from "primereact/multiselect";
import { OverlayPanel } from "primereact/overlaypanel";
import _ from "lodash";
import { SelectButton } from "primereact/selectbutton";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import * as ExcelJS from "exceljs";
import FileSaver from "file-saver";
import moment from "moment";

const filterOptions = ["Today", "7 Days", "30 Days"];

const PriceDifferenceReport = (props) => {
  const initialFilterState = {
    FilterDate: "",
    FromDate: [new Date(), new Date()],
    Item: [],
    Supplier: [],
  };
  const actionBodyTemplateSrNo = (data, props) => {
    return props.rowIndex + 1;
  };

  const [priceDifferenceReportList, setPriceDifferenceReportList] = useState(
    []
  );
  const [userId, setUserId] = useState(null);
  const [globalFilter, setGlobalFilter] = useState(null);
  const [loading, setLoading] = useState(false);
  const [
    filteredPriceDifferenceReportList,
    setFilteredPriceDifferenceReportList,
  ] = useState([]);

  const [itemList, setItemList] = useState([]);
  const [supplierList, setSupplierList] = useState([]);
  const [filterData, setFilterData] = useState(initialFilterState);

  const [userPageAccess, setUserPageAccess] = useState([]);

  const op = useRef(null);

  useEffect(() => {
    let token = localStorage.getItem("Token");
    let data = localStorage.getItem("Infodata");
    let Userrole = JSON.parse(localStorage.getItem("Userdata"));
    let userPageAccess = localStorage.getItem("PageAccess");
    setUserPageAccess(userPageAccess);
    setUserId(data);
    getItemList(data);
    getSupplierList(data);
  }, []);

  useEffect(() => {
    if (!filterData.FilterDate) return;

    const today = moment();
    let range = null;

    switch (filterData.FilterDate) {
      case "Today":
        range = [today.startOf("day").toDate(), today.endOf("day").toDate()];
        break;
      case "7 Days":
        range = [
          moment()
            .subtract(6, "days")
            .startOf("day")
            .toDate(),
          today.endOf("day").toDate(),
        ];
        break;
      case "30 Days":
        range = [
          moment()
            .subtract(29, "days")
            .startOf("day")
            .toDate(),
          today.endOf("day").toDate(),
        ];
        break;
      default:
        range = null;
    }

    if (range) {
      setFilterData((prevState) => ({
        ...prevState,
        FromDate: range,
      }));
    }
  }, [filterData.FilterDate]);

  const getItemList = async (UserId) => {
    let params = {
      UserId,
    };
    api
      .post(APIConstant.path.GetVariantList, params)
      .then((response) => {
        if (response.Success === 1) {
          let filterArry = response.Data.filter((x) => x.UserId != "Admin");
          setItemList(filterArry);
        }
      })
      .catch((err) => {});
  };

  const getSupplierList = async (UserId) => {
    let params = {
      UserId: UserId,
      UserType: "Supplier",
    };
    api
      .post(APIConstant.path.GetNetworkByUserType, params)
      .then((response) => {
        if (response.Success === 1) {
          let filterArry = response.Data.filter((x) => x.UserId != "Admin");
          setSupplierList(filterArry);
        }
      })
      .catch((err) => {});
  };

  const GetPriceDifferenceReport = async (UserId, filter) => {
    let tempFilter = filter || filterData;
    Loader.show();
    if (validate()) {
      try {
        let params = {
          UserId: UserId,
          Filters: tempFilter,
        };
        await api
          .post(APIConstant.path.GetPriceDifferenceReport, params)
          .then(async (res) => {
            if (res.Success === 1) {
              Loader.hide();
              setPriceDifferenceReportList(res.Data);
              setFilteredPriceDifferenceReportList(res.Data);
              op.current.hide();
            } else {
              Loader.hide();
              setPriceDifferenceReportList([]);
              setFilteredPriceDifferenceReportList([]);
              op.current.hide();
            }
          })
          .catch((err) => {
            console.log(err);
            Loader.hide();
          });
      } catch (err) {
        console.error(err);
        Loader.hide();
      }
    } else {
      Loader.hide();
    }
  };

  const validate = () => {
    let isValid = true;

    return isValid;
  };

  const handleReset = (e) => {
    op.current.hide();
    GetPriceDifferenceReport(userId, initialFilterState);
  };

  const handleGlobalFilter = (e) => {
    setGlobalFilter(e.target.value);
    if (priceDifferenceReportList.length) {
      let filteredPriceDifferenceReportList = priceDifferenceReportList;
      if (e.target.value) {
        filteredPriceDifferenceReportList = filteredPriceDifferenceReportList.filter(
          (x) => {
            return (
              x.ItemName.toLowerCase().indexOf(e.target.value.toLowerCase()) !==
              -1
            );
          }
        );
        setFilteredPriceDifferenceReportList(filteredPriceDifferenceReportList);
      }

      setFilteredPriceDifferenceReportList(filteredPriceDifferenceReportList);
    }
  };

  const exportToExcel = async () => {
    if (filteredPriceDifferenceReportList.length) {
      try {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet("Price Difference Report");

        const columns = [
          { header: "Sr.No", field: "Index" },
          { header: "Item Name", field: "ItemName" },
          { header: "Total Purchases", field: "TotalPurchases" },
          { header: "Min Price", field: "MinPrice" },
          { header: "Max Price", field: "MaxPrice" },
          { header: "Average Price", field: "AveragePrice" },
          { header: "Median Price", field: "MedianPrice" },
          { header: "Price Difference", field: "PriceDifference" },
          { header: "Cheapest Supplier", field: "CheapestSupplier" },
          { header: "Most Expensive Supplier", field: "MostExpensiveSupplier" },
        ];

        worksheet.columns = columns.map((col) => ({
          header: col.header,
          key: col.field,
          width: col.header.length < 20 ? 20 : col.header.length + 5,
        }));

        // Totals
        let totalPurchases = 0;
        let totalMinPrice = 0;
        let totalMaxPrice = 0;
        let totalAveragePrice = 0;
        let totalMedianPrice = 0;
        let totalPriceDifference = 0;

        filteredPriceDifferenceReportList.forEach((item, index) => {
          const row = {};
          columns.forEach((col) => {
            row[col.field] =
              col.field === "Index" ? index + 1 : item[col.field] || "";
          });

          totalPurchases += parseFloat(item.TotalPurchases) || 0;
          totalMinPrice += parseFloat(item.MinPrice) || 0;
          totalMaxPrice += parseFloat(item.MaxPrice) || 0;
          totalAveragePrice += parseFloat(item.AveragePrice) || 0;
          totalMedianPrice += parseFloat(item.MedianPrice) || 0;
          totalPriceDifference += parseFloat(item.PriceDifference) || 0;

          worksheet.addRow(row);
        });

        worksheet.addRow([]);

        const totalRow = {};
        columns.forEach((col) => {
          switch (col.field) {
            case "TotalPurchases":
              totalRow[col.field] = totalPurchases;
              break;
            case "MinPrice":
              totalRow[col.field] = totalMinPrice.toFixed(2);
              break;
            case "MaxPrice":
              totalRow[col.field] = totalMaxPrice.toFixed(2);
              break;
            case "AveragePrice":
              totalRow[col.field] = totalAveragePrice.toFixed(2);
              break;
            case "MedianPrice":
              totalRow[col.field] = totalMedianPrice.toFixed(2);
              break;
            case "PriceDifference":
              totalRow[col.field] = totalPriceDifference.toFixed(2);
              break;
            default:
              totalRow[col.field] = "";
          }
        });

        worksheet.addRow(totalRow).font = { bold: true };

        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], {
          type:
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        FileSaver.saveAs(blob, `Price_Difference_Report.xlsx`);
      } catch (error) {
        console.error("Error exporting Price Difference Report:", error);
      }
    }
  };

  return (
    <div className="wayment-owner-dashboard e-weighment-dashoard">
      {loading === true ? (
        <div className="loading">
          <SimpleBackdrop />
        </div>
      ) : null}
      <div className="heading-area p-d-flex p-ai-center p-jc-between">
        <div className="p-d-flex p-ai-center">
          <i className="pi pi-upload"></i>
          <h2>Price Difference Report</h2>
        </div>

        <div className="p-d-flex p-ai-center wb-filter-btn">
          <div className="searchbar-area p-position-relative">
            <InputText
              className="searchbar"
              type="search"
              onChange={(e) => handleGlobalFilter(e)}
              placeholder="Global Search"
              size="30"
              style={{ marginRight: 30 }}
            />
            {!globalFilter ? <i className="icon-search"></i> : null}
          </div>

          <div
            className="e-add-btn"
            onClick={(e) => {
              exportToExcel();
            }}
          >
            <i className="pi pi-file-excel"></i>
          </div>

          <div className="p-position-relative">
            <Button
              onClick={(e) => {
                op.current.toggle(e);
              }}
              icon="icon-filter"
              rounded
              className="wb-search-btn p-ml-2"
            />

            {/* <button onClick={generatePDF}>Export PDF</button> */}
            <div className="header-bar">
              <div className="right-nav-buttons p-d-flex">
                <div>
                  <div className="noti-dropdown-outer">
                    <OverlayPanel
                      ref={op}
                      style={{ width: 500 }}
                      className="wayment-slip-filter"
                    >
                      <div>
                        <div role="menu">
                          <div className="p-grid p-p-2 trip-filter-box">
                            <div className="p-col-12  p-md-12 p-pt-2">
                              <div className="p-w-100 ">
                                <div className="custom-inputs">
                                  <label htmlFor="estimationtime">
                                    Select Date
                                  </label>
                                  <div className="p-d-flex p-ai-center">
                                    <SelectButton
                                      className="wb-filter-dt"
                                      value={filterData.FilterDate}
                                      onChange={(e) => {
                                        setFilterData((prevState) => ({
                                          ...prevState,
                                          FilterDate: e.value,
                                          FromDate: null,
                                        }));
                                      }}
                                      options={filterOptions}
                                    />
                                    <Calendar
                                      dateFormat="dd/mm/yy"
                                      className="p-w-100 p-mt-2"
                                      placeholder="Start Date - End Date"
                                      value={filterData.FromDate}
                                      selectionMode="range"
                                      onChange={(e) => {
                                        e.stopPropagation();
                                        setFilterData((prevState) => ({
                                          ...prevState,
                                          FilterDate: null,
                                          FromDate: e?.value,
                                        }));
                                      }}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="p-col-12  p-md-6 p-pt-2">
                              <div className="p-w-100 ">
                                <div className="custom-inputs">
                                  <label htmlFor="estimationtime">Items</label>
                                  <MultiSelect
                                    className="p-w-100 p-mt-1"
                                    value={filterData.Item}
                                    options={itemList}
                                    optionLabel="label"
                                    display="chip"
                                    fixedPlaceholder={true}
                                    placeholder="Select Items"
                                    onChange={(e) => {
                                      setFilterData((prevState) => ({
                                        ...prevState,
                                        Item: e?.value,
                                      }));
                                      e.stopPropagation();
                                    }}
                                    filter
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="p-col-12  p-md-6 p-pt-2">
                              <div className="p-w-100 ">
                                <div className="custom-inputs">
                                  <label htmlFor="estimationtime">Supplier</label>
                                  <MultiSelect
                                    className="p-w-100 p-mt-1"
                                    value={filterData.Supplier}
                                    options={supplierList}
                                    optionLabel="label"
                                    display="chip"
                                    fixedPlaceholder={true}
                                    placeholder="Select Suppliers"
                                    onChange={(e) => {
                                      setFilterData((prevState) => ({
                                        ...prevState,
                                        Supplier: e?.value,
                                      }));
                                      e.stopPropagation();
                                    }}
                                    filter
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="noti-footer">
                          <div className="p-d-flex p-ml-2 p-mb-1">
                            <Button
                              className="primary-btn1"
                              onClick={(e) => {
                                handleReset(e);
                              }}
                            >
                              Reset
                            </Button>
                            <Button
                              className="primary-btn p-ml-2"
                              onClick={() => GetPriceDifferenceReport(userId)}
                            >
                              Filter
                            </Button>
                          </div>
                        </div>
                      </div>
                    </OverlayPanel>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr />
      <div className="export-custom-large-wb-table">
        <DataTable
          className="main-table table-td"
          value={filteredPriceDifferenceReportList}
          responsiveLayout="scroll"
          totalRecords={filteredPriceDifferenceReportList.length}
          emptyMessage="No records found"
          responsive={false}
          resizableColumns={true}
          columnResizeMode="fit"
          scrollable={true}
          scrollWidth="auto"
        >
          <Column
            field="Index"
            header="Sr.No"
            body={actionBodyTemplateSrNo}
            style={{ width: "6%" }}
          ></Column>

          <Column field="Date" header="Date" style={{ width: "10%" }}></Column>
          <Column
            field="ItemName"
            header="Item Name"
            style={{ width: "10%" }}
          ></Column>
          <Column
            field="TotalPurchases"
            header="Total Purchases"
            style={{ width: "12%" }}
          ></Column>
          <Column
            field="MinPrice"
            header="Min Price"
            style={{ width: "12%" }}
          ></Column>
          <Column
            field="MaxPrice"
            header="Max Price"
            style={{ width: "12%" }}
          ></Column>
          <Column
            field="AveragePrice"
            header="Average Price"
            style={{ width: "12%" }}
          ></Column>
          <Column
            field="MedianPrice"
            header="Median Price"
            style={{ width: "12%" }}
          ></Column>
          <Column
            field="PriceDifference"
            header="Price Difference"
            style={{ width: "12%" }}
          ></Column>
          <Column
            field="CheapestSupplier"
            header="Cheapest Supplier"
            style={{ width: "12%" }}
          ></Column>
          <Column
            field="MostExpensiveSupplier"
            header="Most Expensive Supplier"
            style={{ width: "12%" }}
          ></Column>
        </DataTable>
      </div>
    </div>
  );
};

export default PriceDifferenceReport;
